import React, { Component } from 'react';
import * as addressTools from '@simplybenefits/sb-address';
import Modal from '../Modals/Modal.js';
import Loader from '../Loader.js';
import BubbleSelectBlock from '../BubbleSelectBlock.js';
import Text from '../Text.js';
import TextInput from '../TextFields/TextInput.js';
import PhoneInput from '../TextFields/PhoneInput.js';
import * as Services from '../../services/index.js';
import NumberInput from '../TextFields/NumberInput.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as localizationMaps from '../../localization/maps.js';
class MetaModal extends Component {
  state = {
    companyName: '',
    email: '',
    name: '',
    language: '',
    phone: '',
    authority: '',
    authorityEmail: '',
    suite: '',
    firstLine: '',
    city: '',
    province: '',
    postalCode: '',
    country: 'Canada',
    isASO: false,
    asoType: null,
    isAsoDental: null,
    isAsoHealth: null,
    asoAdminFeePercentage: 7,
    spendingAccountMarkup: 7,
    adjudicationFee: 10,
    allowVoluntaryBenefits: 1,
    allowOptionalBenefits: 0,
    isMarketplaceOnly: 0,
    experienceRatedRateGuarantee: 17,
    pooledRateGuarantee: 29,
    underwritingPeriod: 5
  };
  componentDidMount() {
    if (this.props.isEdit) {
      const address = addressTools.parseAddress(this.props.data.meta.address);
      this.setState({
        companyName: this.props.data.meta.company,
        email: this.props.data.meta.email,
        name: `${this.props.data.meta.firstname} ${this.props.data.meta.lastname}`,
        language: this.props.data.meta.language === "fr" ? i18n.t(tokens.dropdowns.languages.french) : i18n.t(tokens.dropdowns.languages.english),
        phone: this.props.data.meta.phone,
        authority: this.props.data.meta.authority.name,
        authorityEmail: this.props.data.meta.authority.email,
        suite: address.suite || '',
        firstLine: address.firstLine || '',
        city: address.city || '',
        province: localizationMaps.fromEnglish("provinces", address.province) || '',
        postalCode: address.postalCode || '',
        country: this.props.data.meta.country,
        isASO: this.props.data.meta.aso.isASO,
        asoType: this.props.data.meta.aso.asoType || null,
        isAsoDental: this.props.data.meta.aso.isAsoDental,
        isAsoHealth: this.props.data.meta.aso.isAsoHealth,
        asoAdminFeePercentage: this.props.data.meta.aso.asoAdminFeePercentage || 7,
        spendingAccountMarkup: this.props.data.meta.spendingAccountMarkup || 7,
        adjudicationFee: this.props.data.meta.adjudicationFee || 10,
        allowVoluntaryBenefits: this.props.data.meta.allowVoluntaryBenefits,
        allowOptionalBenefits: this.props.data.meta.allowOptionalBenefits,
        isMarketplaceOnly: this.props.data.meta.isMarketplaceOnly,
        experienceRatedRateGuarantee: this.props.data.meta.experienceRatedRateGuarantee || 17,
        pooledRateGuarantee: this.props.data.meta.pooledRateGuarantee || 29,
        underwritingPeriod: this.props.data.meta.underwritingPeriod || 5
      });
    }
  }
  _onBlur = async type => {
    this.setState({
      [`${type}Error`]: await Services.validateInput(type || "checkEmpty", this.state[type])
    });
  };
  _onAddressBlur = async type => {
    if (type !== 'suite') {
      await this.setState({
        [`${type}Error`]: await Services.validateInput(type, this.state[type])
      });
    }
    const {
      firstLine,
      city,
      province,
      postalCode
    } = this.state;
    if (firstLine && city && province && postalCode) {
      await addressTools.generateAddress(this.state);
    }
    return null;
  };
  _handleAddressChange = (type, event) => {
    this.setState({
      [type]: event.target.value.replace(/,/g, '')
    });
  };
  _handleInputChange = (type, event, isValue) => {
    this.setState({
      [type]: isValue ? event : event.target.value
    });
  };
  _validateForm = async () => {
    const companyNameError = await Services.validateInput('companyName', this.state.companyName);
    const emailError = await Services.validateInput('email', this.state.email);
    const nameError = await Services.validateInput('name', this.state.name);
    const phoneError = await Services.validateInput('phone', this.state.phone);
    const authorityError = await Services.validateInput('name', this.state.name);
    const authorityEmailError = await Services.validateInput('authorityEmail', this.state.authorityEmail);
    const firstLineError = await Services.validateInput('firstLine', this.state.firstLine);
    const cityError = await Services.validateInput('city', this.state.city);
    const provinceError = await Services.validateInput('province', this.state.province);
    const postalCodeError = await Services.validateInput('postalCode', this.state.postalCode);
    const asoAdminFeePercentageError = await Services.validateInput("checkEmpty", this.state.asoAdminFeePercentage);
    const spendingAccountMarkupError = await Services.validateInput("checkEmpty", this.state.spendingAccountMarkup);
    const adjudicationFeeError = await Services.validateInput("checkEmpty", this.state.adjudicationFee);
    const experienceRatedRateGuaranteeError = await Services.validateInput('checkEmpty', this.state.experienceRatedRateGuarantee);
    const pooledRateGuaranteeError = await Services.validateInput('checkEmpty', this.state.pooledRateGuarantee);
    const underwritingPeriodError = await Services.validateInput('checkEmpty', this.state.underwritingPeriod);
    this.setState({
      companyNameError,
      emailError,
      authorityError,
      authorityEmailError,
      firstLineError,
      cityError,
      provinceError,
      postalCodeError,
      nameError,
      phoneError,
      asoAdminFeePercentageError,
      spendingAccountMarkupError,
      adjudicationFeeError,
      experienceRatedRateGuaranteeError,
      pooledRateGuaranteeError,
      underwritingPeriodError
    });
    if (companyNameError || emailError || authorityError || authorityEmailError || firstLineError || cityError || provinceError || postalCodeError || nameError || phoneError || asoAdminFeePercentageError || spendingAccountMarkupError || adjudicationFeeError || experienceRatedRateGuaranteeError || pooledRateGuaranteeError || underwritingPeriodError) {
      return false;
    }
    return true;
  };
  _edit = async () => {
    const isValid = await this._validateForm();
    if (!isValid) {
      return false;
    }
    const generatedAddress = addressTools.generateAddress({
      suite: this.state.suite,
      firstLine: this.state.firstLine,
      city: this.state.city,
      province: localizationMaps.toEnglish('provinces', this.state.province),
      postalCode: this.state.postalCode,
      country: this.state.country
    });
    const adminTemp = this.state.name.trim().split(' ');
    const success = await this.props.edit({
      companyName: this.state.companyName.trim(),
      companyAddress: generatedAddress.trim(),
      email: this.state.email.trim(),
      firstname: adminTemp[0],
      lastname: adminTemp[1],
      language: localizationMaps.toEnglish("languages", this.state.language) === "French" ? "fr" : "en",
      phone: this.state.phone.trim(),
      authorityName: this.state.authority.trim(),
      authorityEmail: this.state.authorityEmail.trim(),
      isASO: Boolean(this.state.isASO),
      asoType: this.state.asoType,
      isAsoDental: Number(this.state.isAsoDental),
      isAsoHealth: Number(this.state.isAsoHealth),
      asoAdminFeePercentage: this.state.asoAdminFeePercentage,
      spendingAccountMarkup: this.state.spendingAccountMarkup,
      adjudicationFee: this.state.adjudicationFee,
      allowVoluntaryBenefits: Boolean(this.state.allowVoluntaryBenefits),
      allowOptionalBenefits: Boolean(this.state.allowOptionalBenefits),
      isMarketplaceOnly: Boolean(this.state.isMarketplaceOnly),
      experienceRatedRateGuarantee: Number(this.state.experienceRatedRateGuarantee),
      pooledRateGuarantee: Number(this.state.pooledRateGuarantee),
      underwritingPeriod: Number(this.state.underwritingPeriod)
    });
    if (success) {
      this.props.hideModal();
    }
    return null;
  };
  _create = async () => {
    const isValid = await this._validateForm();
    if (!isValid) {
      return false;
    }
    const generatedAddress = addressTools.generateAddress({
      suite: this.state.suite,
      firstLine: this.state.firstLine,
      city: this.state.city,
      province: localizationMaps.toEnglish('provinces', this.state.province),
      postalCode: this.state.postalCode,
      country: this.state.country
    });
    const adminTemp = this.state.name.trim().split(' ');
    const success = await this.props.create({
      companyName: this.state.companyName.trim(),
      companyAddress: generatedAddress.trim(),
      email: this.state.email.trim(),
      firstname: adminTemp[0],
      lastname: adminTemp[1],
      language: localizationMaps.toEnglish("languages", this.state.language) === "French" ? "fr" : "en",
      phone: this.state.phone.trim(),
      authorityName: this.state.authority.trim(),
      authorityEmail: this.state.authorityEmail.trim(),
      isASO: Boolean(this.state.isASO),
      asoType: this.state.asoType,
      isAsoDental: Number(this.state.isAsoDental),
      isAsoHealth: Number(this.state.isAsoHealth),
      asoAdminFeePercentage: this.state.asoAdminFeePercentage,
      spendingAccountMarkup: this.state.spendingAccountMarkup,
      adjudicationFee: this.state.adjudicationFee,
      allowVoluntaryBenefits: Boolean(this.state.allowVoluntaryBenefits),
      allowOptionalBenefits: Boolean(this.state.allowOptionalBenefits),
      isMarketplaceOnly: Boolean(this.state.isMarketplaceOnly),
      experienceRatedRateGuarantee: Number(this.state.experienceRatedRateGuarantee),
      pooledRateGuarantee: Number(this.state.pooledRateGuarantee),
      underwritingPeriod: Number(this.state.underwritingPeriod)
    });
    if (success) {
      this.props.hideModal();
    }
    return null;
  };
  render() {
    const {
      showModal,
      hideModal,
      isRevision,
      isMasterSite
    } = this.props;
    const styles = {
      row: {
        display: 'flex',
        flexDirection: 'row'
      },
      divider: {
        width: 40
      }
    };
    return /*#__PURE__*/React.createElement(Modal, {
      medium: true,
      open: showModal,
      onClose: hideModal,
      title: this.props.isEdit ? i18n.t(tokens.titles.editDetails) : i18n.t(tokens.titles.createQuote),
      primaryButton: {
        onClick: this.props.isEdit ? this._edit : this._create
      }
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true
    }, "Group Details"), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.account.companyName),
      value: this.state.companyName,
      onBlur: e => this._onBlur('companyName', e),
      onChange: value => this._handleInputChange('companyName', value),
      error: Boolean(this.state.companyNameError),
      helperText: this.state.companyNameError,
      fullWidth: true,
      autofocus: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.row
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.account.contactEmail),
      onBlur: e => this._onBlur('email', e),
      value: this.state.email,
      onChange: value => this._handleInputChange('email', value),
      error: Boolean(this.state.emailError),
      helperText: this.state.emailError,
      fullWidth: true,
      autofocus: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.divider
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.account.adminName),
      value: this.state.name,
      onBlur: e => this._onBlur('name', e),
      onChange: value => this._handleInputChange('name', value),
      error: Boolean(this.state.nameError),
      helperText: this.state.nameError,
      fullWidth: true
    })), /*#__PURE__*/React.createElement("div", {
      style: styles.row
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.quotes.adminLanguage),
      value: this.state.language,
      onBlur: () => this._onBlur('language'),
      onChange: value => this._handleInputChange('language', value),
      select: true,
      selectOptions: Services.selectFieldOptions.languageOptions(),
      fullWidth: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.divider
    }), /*#__PURE__*/React.createElement(PhoneInput, {
      label: i18n.t(tokens.labels.account.companyContactNumber),
      onBlur: e => this._onBlur('phone', e),
      value: this.state.phone,
      onChange: value => this._handleInputChange('phone', value),
      error: Boolean(this.state.phoneError),
      helperText: this.state.phoneError,
      fullWidth: true
    })), /*#__PURE__*/React.createElement("div", {
      style: styles.row
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.account.signingAuthorityName),
      onBlur: e => this._onBlur('authority', e),
      value: this.state.authority,
      onChange: value => this._handleInputChange('authority', value),
      error: Boolean(this.state.authorityError),
      helperText: this.state.authorityError,
      fullWidth: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.divider
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.account.signingAuthorityEmail),
      value: this.state.authorityEmail,
      onBlur: e => this._onBlur('authorityEmail', e),
      onChange: value => this._handleInputChange('authorityEmail', value),
      error: Boolean(this.state.authorityEmailError),
      helperText: this.state.authorityEmailError,
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      margin: "20px 0 0px 0"
    }, "Address Information"), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.streetAddress),
      value: this.state.firstLine,
      autocomplete: "shipping street-address",
      onBlur: e => this._onAddressBlur('firstLine', e),
      onChange: value => this._handleAddressChange('firstLine', value),
      error: Boolean(this.state.firstLineError),
      helperText: this.state.firstLineError,
      fullWidth: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.row
    }, /*#__PURE__*/React.createElement(TextInput, {
      value: this.state.suite,
      label: i18n.t(tokens.labels.account.suiteUnit),
      onBlur: e => this._onAddressBlur('suite', e),
      onChange: value => this._handleAddressChange('suite', value),
      fullWidth: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.divider
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.account.cityTown),
      value: this.state.city,
      onBlur: e => this._onAddressBlur('city', e),
      onChange: value => this._handleAddressChange('city', value),
      error: Boolean(this.state.cityError),
      helperText: this.state.cityError,
      fullWidth: true
    })), /*#__PURE__*/React.createElement("div", {
      style: styles.row
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.province),
      value: this.state.province,
      onBlur: e => this._onAddressBlur('province', e),
      onChange: value => this._handleInputChange('province', value),
      error: Boolean(this.state.provinceError),
      helperText: this.state.provinceError,
      select: true,
      selectOptions: Services.selectFieldOptions.provinceOptions(),
      fullWidth: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.divider
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.postalCode),
      value: this.state.postalCode,
      onBlur: e => this._onAddressBlur('postalCode', e),
      onChange: value => this._handleAddressChange('postalCode', value),
      error: Boolean(this.state.postalCodeError),
      helperText: this.state.postalCodeError,
      fullWidth: true
    })), isMasterSite && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      margin: "20px 0 0px 0"
    }, "Rate Guarantees"), /*#__PURE__*/React.createElement("div", {
      style: styles.row
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: "Experience Rated Benefits Rate Guarantee",
      value: this.state.experienceRatedRateGuarantee,
      onBlur: () => this._onBlur('experienceRatedRateGuarantee'),
      onChange: value => this._handleInputChange('experienceRatedRateGuarantee', value),
      error: Boolean(this.state.experienceRatedRateGuaranteeError),
      helperText: this.state.experienceRatedRateGuaranteeError,
      disabled: isRevision,
      fullWidth: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.divider
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: "Pooled Benefits Rate Guarantee",
      value: this.state.pooledRateGuarantee,
      onBlur: () => this._onBlur('pooledRateGuarantee'),
      onChange: value => this._handleInputChange('pooledRateGuarantee', value),
      error: Boolean(this.state.pooledRateGuaranteeError),
      helperText: this.state.pooledRateGuaranteeError,
      disabled: isRevision,
      fullWidth: true
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.divider
    }), /*#__PURE__*/React.createElement(TextInput, {
      label: "Underwriting Period",
      value: this.state.underwritingPeriod,
      onBlur: () => this._onBlur('underwritingPeriod'),
      onChange: value => this._handleInputChange('underwritingPeriod', value),
      error: Boolean(this.state.underwritingPeriodError),
      helperText: this.state.underwritingPeriodError,
      disabled: isRevision,
      fullWidth: true
    })), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      bold: true,
      margin: "20px 0 0px 0"
    }, "Group Add-Ons"), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      light: true,
      margin: "20px 0 0px 0"
    }, i18n.t(tokens.labels.account.isMarketplaceOnly)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.yes),
        selected: Boolean(this.state.isMarketplaceOnly) === true,
        field: 'isMarketplaceOnlyYes'
      },
      second: {
        title: i18n.t(tokens.labels.no),
        selected: Boolean(this.state.isMarketplaceOnly) === false,
        field: 'isMarketplaceOnlyNo'
      },
      onBlur: e => this._onBlur('isMarketplaceOnly', e),
      handleChange: async field => {
        if (field === 'isMarketplaceOnlyYes') {
          await this._handleInputChange('isMarketplaceOnly', true, true);
        } else {
          await this._handleInputChange('isMarketplaceOnly', false, true);
        }
      }
    }),
    // eslint-disable-next-line no-extra-boolean-cast
    !this.props.advisorMeta.privateLabelID && !this.state.isMarketplaceOnly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      light: true,
      margin: "20px 0 0px 0"
    }, i18n.t(tokens.labels.account.includeOptionBenefits)), /*#__PURE__*/React.createElement(Text, {
      tiny: true,
      light: true,
      margin: "5px 0 5px 0"
    }, i18n.t(tokens.labels.account.includeOptionBenefitsMemo)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      disabled: true,
      first: {
        title: i18n.t(tokens.labels.yes),
        selected: Boolean(this.state.allowOptionalBenefits) === true,
        field: 'allowOptionalBenefitsYes'
      },
      second: {
        title: i18n.t(tokens.labels.no),
        selected: Boolean(this.state.allowOptionalBenefits) === false,
        field: 'allowOptionalBenefitsNo'
      },
      onBlur: e => this._onBlur('allowOptionalBenefits', e),
      handleChange: async field => {
        if (field === 'allowOptionalBenefitsYes') {
          await this._handleInputChange('allowOptionalBenefits', true, true);
        } else {
          await this._handleInputChange('allowOptionalBenefits', false, true);
        }
      }
    }), /*#__PURE__*/React.createElement(Text, {
      medium: true,
      light: true,
      margin: "20px 0 5px 0"
    }, i18n.t(tokens.labels.account.includeVoluntaryBenefits)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.yes),
        selected: Boolean(this.state.allowVoluntaryBenefits) === true,
        field: 'allowVoluntaryBenefitsYes'
      },
      second: {
        title: i18n.t(tokens.labels.no),
        selected: Boolean(this.state.allowVoluntaryBenefits) === false,
        field: 'allowVoluntaryBenefitsNo'
      },
      onBlur: e => this._onBlur('allowVoluntaryBenefits', e),
      handleChange: async field => {
        if (field === 'allowVoluntaryBenefitsYes') {
          await this._handleInputChange('allowVoluntaryBenefits', true, true);
        } else {
          await this._handleInputChange('allowVoluntaryBenefits', false, true);
        }
      }
    }), isRevision && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.account.adjudicationFee),
      suffix: "%",
      value: this.state.adjudicationFee,
      onChange: value => this._handleInputChange('adjudicationFee', value),
      error: Boolean(this.state.adjudicationFeeError),
      helperText: this.state.adjudicationFeeError,
      fullWidth: true
    }), /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.account.spendingAccountMarkup),
      suffix: "%",
      value: this.state.spendingAccountMarkup,
      onChange: value => this._handleInputChange('spendingAccountMarkup', value),
      error: Boolean(this.state.spendingAccountMarkupError),
      helperText: this.state.spendingAccountMarkupError,
      fullWidth: true
    })))), !this.props.advisorMeta.privateLabelID && !this.state.isMarketplaceOnly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      medium: true,
      light: true,
      margin: "20px 0 5px 0"
    }, i18n.t(tokens.labels.account.asoHealthOrDental)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.yes),
        selected: Boolean(this.state.isASO) === true,
        field: 'isAsoYes'
      },
      second: {
        title: i18n.t(tokens.labels.no),
        selected: Boolean(this.state.isASO) === false,
        field: 'isAsoNo'
      },
      onBlur: e => this._onBlur('isASO', e),
      handleChange: async field => {
        if (field === 'isAsoYes') {
          await this._handleInputChange('isASO', true, true);
        } else {
          await this._handleInputChange('isASO', false, true);
        }
      }
    }), this.state.isASO && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.account.asoType)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.account.budgeted),
        selected: this.state.asoType === 'Budgeted',
        field: 'Budgeted'
      },
      second: {
        title: i18n.t(tokens.labels.account.inArrears),
        selected: this.state.asoType === 'Arrears',
        field: 'Arrears'
      },
      handleChange: async field => {
        await this._handleInputChange('asoType', field, true);
      }
    }), /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.account.asoDental)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.yes),
        selected: this.state.isAsoDental === 1,
        field: 'isAsoDentalYes'
      },
      second: {
        title: i18n.t(tokens.labels.no),
        selected: this.state.isAsoDental === 0,
        field: 'isAsoDentalNo'
      },
      onBlur: e => this._onBlur('isAsoDental', e),
      handleChange: async field => {
        if (field === 'isAsoDentalYes') {
          await this._handleInputChange('isAsoDental', 1, true);
        } else {
          await this._handleInputChange('isAsoDental', 0, true);
        }
      }
    }), /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true,
      margin: "10px 0 0 0"
    }, i18n.t(tokens.labels.account.asoHealth)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
      first: {
        title: i18n.t(tokens.labels.yes),
        selected: this.state.isAsoHealth === 1,
        field: 'isAsoHealthYes'
      },
      second: {
        title: i18n.t(tokens.labels.no),
        selected: this.state.isAsoHealth === 0,
        field: 'isAsoHealthNo'
      },
      onBlur: e => this._onBlur('isAsoHealth', e),
      handleChange: async field => {
        if (field === 'isAsoHealthYes') {
          await this._handleInputChange('isAsoHealth', 1, true);
        } else {
          await this._handleInputChange('isAsoHealth', 0, true);
        }
      }
    }), isRevision && this.state.isASO && (this.state.isAsoHealth === 1 || this.state.isAsoDental === 1) && /*#__PURE__*/React.createElement(NumberInput, {
      label: i18n.t(tokens.labels.account.asoAdminFee),
      suffix: "%",
      value: this.state.asoAdminFeePercentage,
      onChange: value => this._handleInputChange('asoAdminFeePercentage', value),
      error: Boolean(this.state.asoAdminFeePercentageError),
      helperText: this.state.asoAdminFeePercentageError,
      fullWidth: true
    }))), this.props.loader?.isLoading && /*#__PURE__*/React.createElement(Loader, {
      isModal: true
    }), /*#__PURE__*/React.createElement("span", {
      id: "createQuoteModal"
    }));
  }
}
export default MetaModal;